import axios from "axios";
import React from "react";
import summaryApi from "../common/Api";
import { clearUser } from "../store/userSlice";
import { logout } from "../store/authSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const LogOutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = async () => {
    try {
      await axios.post(summaryApi.logOut.url, {}, { withCredentials: true });
      dispatch(clearUser());
      dispatch(logout()); // Dispatch logout action
      Cookies.remove("token");
      Cookies.remove("tokenApi");
      Cookies.remove("user");
      Cookies.remove("connect.sid"); // If you use express-session

      toast.success("Logout Successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      
      // Use the navigate function to redirect
      navigate("/"); // Correct usage of navigate
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <>
      {/* For Desktop */}
      <div className="hidden md:flex bg-black hover:bg-red-700 transition-all text-white w-[80px] text-center items-center justify-center rounded-md">
        <Link to="/" style={{ fontSize: "18px" }} onClick={logOut}>
          LogOut
        </Link>
      </div>

      {/* For Mobile */}
      <div className="flex md:hidden bg-black hover:bg-red-500 py-1 font-bold px-4 text-white w-[80px] text-center items-center justify-center rounded-md">
        <Link to="/" style={{ fontSize: "18px" }} onClick={logOut}>
          LogOut
        </Link>
      </div>
    </>
  );
};

export default LogOutPage;
